"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.filterEntityData = exports.getChooserConfig = void 0;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = require("react");
var draft_js_1 = require("draft-js");
var draftail_1 = require("draftail");
var wagtailConfig_1 = require("../../../config/wagtailConfig");
var DraftUtils_1 = require("../DraftUtils");
var $ = global.jQuery;
var EMBED = 'EMBED';
var DOCUMENT = 'DOCUMENT';
var MUTABILITY = {};
MUTABILITY[draftail_1.ENTITY_TYPE.LINK] = 'MUTABLE';
MUTABILITY[DOCUMENT] = 'MUTABLE';
MUTABILITY[draftail_1.ENTITY_TYPE.IMAGE] = 'IMMUTABLE';
MUTABILITY[EMBED] = 'IMMUTABLE';
exports.getChooserConfig = function (entityType, entity, selectedText) {
    var url;
    var urlParams;
    switch (entityType.type) {
        case draftail_1.ENTITY_TYPE.IMAGE:
            if (entity) {
                var data = entity.getData();
                url = "" + global.chooserUrls.imageChooser + data.id + "/select_format/";
                urlParams = {
                    format: data.format,
                    alt_text: data.alt,
                };
            }
            else {
                url = global.chooserUrls.imageChooser + "?select_format=true";
                urlParams = {};
            }
            return {
                url: url,
                urlParams: urlParams,
                onload: global.IMAGE_CHOOSER_MODAL_ONLOAD_HANDLERS,
            };
        case EMBED:
            urlParams = {};
            if (entity) {
                urlParams.url = entity.getData().url;
            }
            return {
                url: global.chooserUrls.embedsChooser,
                urlParams: urlParams,
                onload: global.EMBED_CHOOSER_MODAL_ONLOAD_HANDLERS,
            };
        case draftail_1.ENTITY_TYPE.LINK:
            url = global.chooserUrls.pageChooser;
            urlParams = {
                page_type: 'wagtailcore.page',
                allow_external_link: true,
                allow_email_link: true,
                allow_phone_link: true,
                allow_anchor_link: true,
                link_text: selectedText,
            };
            if (entity) {
                var data = entity.getData();
                if (data.id) {
                    if (data.parentId !== null) {
                        url = "" + global.chooserUrls.pageChooser + data.parentId + "/";
                    }
                    else {
                        url = global.chooserUrls.pageChooser;
                    }
                }
                else if (data.url.startsWith('mailto:')) {
                    url = global.chooserUrls.emailLinkChooser;
                    urlParams.link_url = data.url.replace('mailto:', '');
                }
                else if (data.url.startsWith('tel:')) {
                    url = global.chooserUrls.phoneLinkChooser;
                    urlParams.link_url = data.url.replace('tel:', '');
                }
                else if (data.url.startsWith('#')) {
                    url = global.chooserUrls.anchorLinkChooser;
                    urlParams.link_url = data.url.replace('#', '');
                }
                else {
                    url = global.chooserUrls.externalLinkChooser;
                    urlParams.link_url = data.url;
                }
            }
            return {
                url: url,
                urlParams: urlParams,
                onload: global.PAGE_CHOOSER_MODAL_ONLOAD_HANDLERS,
            };
        case DOCUMENT:
            return {
                url: global.chooserUrls.documentChooser,
                urlParams: {},
                onload: global.DOCUMENT_CHOOSER_MODAL_ONLOAD_HANDLERS,
            };
        default:
            return {
                url: null,
                urlParams: {},
                onload: {},
            };
    }
};
exports.filterEntityData = function (entityType, data) {
    switch (entityType.type) {
        case draftail_1.ENTITY_TYPE.IMAGE:
            return {
                id: data.id,
                src: data.preview.url,
                alt: data.alt,
                format: data.format,
            };
        case EMBED:
            return {
                embedType: data.embedType,
                url: data.url,
                providerName: data.providerName,
                authorName: data.authorName,
                thumbnail: data.thumbnail,
                title: data.title,
            };
        case draftail_1.ENTITY_TYPE.LINK:
            if (data.id) {
                return {
                    url: data.url,
                    id: data.id,
                    parentId: data.parentId,
                };
            }
            return {
                url: data.url,
            };
        case DOCUMENT:
            return {
                url: data.url,
                filename: data.filename,
                id: data.id,
            };
        default:
            return {};
    }
};
/**
 * Interfaces with Wagtail's ModalWorkflow to open the chooser,
 * and create new content in Draft.js based on the data.
 */
var ModalWorkflowSource = /** @class */ (function (_super) {
    __extends(ModalWorkflowSource, _super);
    function ModalWorkflowSource(props) {
        var _this = _super.call(this, props) || this;
        _this.onChosen = _this.onChosen.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        return _this;
    }
    ModalWorkflowSource.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, onClose = _a.onClose, entityType = _a.entityType, entity = _a.entity, editorState = _a.editorState;
        var selectedText = DraftUtils_1.getSelectionText(editorState);
        var _b = exports.getChooserConfig(entityType, entity, selectedText), url = _b.url, urlParams = _b.urlParams, onload = _b.onload;
        $(document.body).on('hidden.bs.modal', this.onClose);
        // eslint-disable-next-line new-cap
        this.workflow = global.ModalWorkflow({
            url: url,
            urlParams: urlParams,
            onload: onload,
            responses: {
                imageChosen: this.onChosen,
                // Discard the first parameter (HTML) to only transmit the data.
                embedChosen: function (_, data) { return _this.onChosen(data); },
                documentChosen: this.onChosen,
                pageChosen: this.onChosen,
            },
            onError: function () {
                // eslint-disable-next-line no-alert
                window.alert(wagtailConfig_1.STRINGS.SERVER_ERROR);
                onClose();
            },
        });
    };
    ModalWorkflowSource.prototype.componentWillUnmount = function () {
        this.workflow = null;
        $(document.body).off('hidden.bs.modal', this.onClose);
    };
    ModalWorkflowSource.prototype.onChosen = function (data) {
        var _a = this.props, editorState = _a.editorState, entity = _a.entity, entityKey = _a.entityKey, entityType = _a.entityType, onComplete = _a.onComplete;
        var content = editorState.getCurrentContent();
        var selection = editorState.getSelection();
        var entityData = exports.filterEntityData(entityType, data);
        var mutability = MUTABILITY[entityType.type];
        var nextState;
        if (entityType.block) {
            if (entity && entityKey) {
                // Replace the data for the currently selected block
                var blockKey = selection.getAnchorKey();
                var block = content.getBlockForKey(blockKey);
                nextState = draftail_1.DraftUtils.updateBlockEntity(editorState, block, entityData);
            }
            else {
                // Add new entity if there is none selected
                var contentWithEntity = content.createEntity(entityType.type, mutability, entityData);
                var newEntityKey = contentWithEntity.getLastCreatedEntityKey();
                nextState = draft_js_1.AtomicBlockUtils.insertAtomicBlock(editorState, newEntityKey, ' ');
            }
        }
        else {
            var contentWithEntity = content.createEntity(entityType.type, mutability, entityData);
            var newEntityKey = contentWithEntity.getLastCreatedEntityKey();
            // Replace text if the chooser demands it, or if there is no selected text in the first place.
            var shouldReplaceText = data.prefer_this_title_as_link_text || selection.isCollapsed();
            if (shouldReplaceText) {
                // If there is a title attribute, use it. Otherwise we inject the URL.
                var newText = data.title || data.url;
                var newContent = draft_js_1.Modifier.replaceText(content, selection, newText, null, newEntityKey);
                nextState = draft_js_1.EditorState.push(editorState, newContent, 'insert-characters');
            }
            else {
                nextState = draft_js_1.RichUtils.toggleLink(editorState, selection, newEntityKey);
            }
        }
        // IE11 crashes when rendering the new entity in contenteditable if the modal is still open.
        // Other browsers do not mind. This is probably a focus management problem.
        // From the user's perspective, this is all happening too fast to notice either way.
        this.workflow.close();
        onComplete(nextState);
    };
    ModalWorkflowSource.prototype.onClose = function (e) {
        var onClose = this.props.onClose;
        e.preventDefault();
        onClose();
    };
    ModalWorkflowSource.prototype.render = function () {
        return null;
    };
    return ModalWorkflowSource;
}(react_1.Component));
ModalWorkflowSource.propTypes = {
    editorState: prop_types_1["default"].object.isRequired,
    entityType: prop_types_1["default"].object.isRequired,
    entity: prop_types_1["default"].object,
    entityKey: prop_types_1["default"].string,
    onComplete: prop_types_1["default"].func.isRequired,
    onClose: prop_types_1["default"].func.isRequired,
};
ModalWorkflowSource.defaultProps = {
    entity: null,
};
exports["default"] = ModalWorkflowSource;
